<template>
  <div>
    <div class="panel panel-default">
      <div v-if="!!title" class="panel-heading">
        <h4 class="custom-font">{{ title }}</h4>
      </div>
      <div class="panel-body">
        <div class="row">
          <slot name="filters"></slot>
        </div>
        <div class="row margem-topo form-group">
          <div class="col-xs-12">
            <print-table :title="reportTitle" v-if="showPrintButton" :fields="fieldsDefinition" :api-url="restUrl"
              :append-params="params" class="pull-right hidden-xs"></print-table>
            <div class="actions pull-left">
              <slot name="actions"></slot>
            </div>
            <!-- <filter-bar :fields="fieldsDefinition" class="pull-right" v-if="useFilter"></filter-bar> -->
            <column-visibility v-if="showColumnVisibilityButton" :fields.sync="fieldsDefinition"
              class="pull-right hidden-xs">
            </column-visibility>
            <pulse-loader :loading="carregando"></pulse-loader>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12" style="overflow: auto">
            <vuetable class="custom-table-font" ref="vuetable" :load-on-start="loadOnStart" :api-url="restUrl"
              :api-mode="apiMode" :fields="fieldsDefinition" :css="css.table" :data-path="dataPath" :data="data"
              :http-options="auth" :pagination-path="paginationPath" :per-page="itemsPerPage" :append-params="params"
              :muti-sort="multiSort" :multi-sort-key="multiSortKey" :initial-page="initialPage"
              @vuetable:loading="carregando = true" @vuetable:loaded="carregando = false"
              no-data-template="Nenhum registro encontrado." @vuetable:pagination-data="onPaginationData"
              @vuetable:load-success="onSuccess" @vuetable:load-error="onError">
              <template slot="icon" slot-scope="props">
                <slot name="icon" :rowData="props.rowData"></slot>
                <!-- <img src="https://cdn.auth0.com/blog/vuejs/vue-logo.png" alt="" width="48" height="48"> -->
              </template>
              <template slot="icon1" slot-scope="props">
                <slot name="ano1" :rowData="props.rowData"></slot>
              </template>
              <template slot="icon2" slot-scope="props">
                <slot name="ano2" :rowData="props.rowData"></slot>
              </template>
              <template slot="icon3" slot-scope="props">
                <slot name="ano3" :rowData="props.rowData"></slot>
              </template>
              <template slot="icon4" slot-scope="props">
                <slot name="ano4" :rowData="props.rowData"></slot>
              </template>

              <template slot="column_custom" slot-scope="props">
                <slot name="custom" :rowData="props.rowData"></slot>
              </template>

              <template slot="column_custom_2" slot-scope="props">
                <slot name="custom_2" :rowData="props.rowData"></slot>
              </template>

              <template slot="actions" slot-scope="props">
                <slot name="rowrender" :rowData="props.rowData"></slot>
              </template>
              <template v-for="item in slots" :slot="item" slot-scope="props">
                <slot :name="item" :rowData="props.rowData"></slot>
              </template>
              <template slot="noDataTemplate">
                <pulse-loader :loading="carregando"></pulse-loader>
              </template>
            </vuetable>
          </div>
        </div>
      </div>

      <div class="panel-footer">
        <pagination ref="pagination" :css="css.pagination" :icons="css.icons"
          @vuetable-pagination:change-page="onChangePage">
        </pagination>

        <pagination-info ref="paginationInfo" :css="css.paginationInfo"
          info-template="Registro(s) {from} ao {to} de um total de {total}" no-data-template="Nenhum registro"
          class="pull-left custom-table-font">
        </pagination-info>
        <div class="clearfix"></div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import request from '@/request'
import vuetable from 'vuetable-2/src/components/Vuetable'
import pagination from 'vuetable-2/src/components/VuetablePagination'
import paginationInfo from 'vuetable-2/src/components/VuetablePaginationInfo'
import filterBar from '@/components/common/FilterBar'
import columnVisibility from '@/components/vuetable2-column-visibility'
import printTable from '@/components/common/PrintTable'
import vueEvents from 'vue-events'
import router from '@/router'
import store from '@/store'
Vue.use(vueEvents)

export default {
  name: 'data-table',
  components: {
    vuetable,
    printTable,
    pagination,
    paginationInfo,
    filterBar,
    columnVisibility
  },
  data() {
    return {
      fieldsDefinition: this.fields,
      totalRows: 0,
      carregando: false
    }
  },
  props: {
    hasAuth: {
      type: Boolean,
      default: true
    },
    loadOnStart: {
      type: Boolean,
      default: true
    },
    slots: {
      type: Array,
      default: () => {
        return []
      }
    },
    refresh: {
      type: Function,
      default() {
        this.$refs.vuetable.refresh()
      }
    },
    useFilter: {
      type: Boolean,
      default: true
    },
    title: String,
    reportTitle: String,
    apiUrl: String,
    apiMode: {
      type: Boolean,
      default: true
    },
    showEmpty: {
      type: Boolean,
      default: false
    },
    showPrintButton: {
      type: Boolean,
      default: true
    },
    showColumnVisibilityButton: {
      type: Boolean,
      default: true
    },
    reference: String,
    appendParams: Object,
    fields: Array,
    multiSort: {
      type: Boolean,
      default: true
    },
    multiSortKey: {
      type: String,
      default: 'ctrl'
    },
    dataPath: {
      type: String,
      default: 'data'
    },
    data: {
      type: Array,
      required: false
    },
    paginationPath: {
      type: String,
      default: ''
    },
    css: {
      type: Object,
      default: function () {
        return {
          table: {
            tableClass: 'table table-striped table-hover',
            ascendingIcon: 'glyphicon glyphicon-chevron-up',
            descendingIcon: 'glyphicon glyphicon-chevron-down'
          },
          pagination: {
            wrapperClass: 'pagination pull-right',
            activeClass: 'btn-primary',
            disabledClass: 'disabled',
            pageClass: 'btn btn-border',
            linkClass: 'btn btn-border',
            icons: {
              first: 'glyphicon glyphicon-step-backward',
              prev: 'glyphicon glyphicon-chevron-left',
              next: 'glyphicon glyphicon-chevron-right',
              last: 'glyphicon glyphicon-step-forward'
            }
          }
        }
      }
    },
    itemsPerPage: {
      type: Number,
      default: 10
    },
    initialPage: {
      type: Number,
      default: 1
    },
    pageCollection: {
      type: String,
      required: false
    }
  },
  computed: {
    restUrl() {
      return request.apiUrlRoot + this.apiUrl
    },
    auth() {
      if (this.hasAuth) {
        return { headers: request.apiHeaderAuthorization() }
      } else {
        return {}
      }
    },
    params() {
      return this.appendParams
    }
  },
  methods: {
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData)
      this.$refs.paginationInfo.setPaginationData(paginationData)
    },
    onChangePage(page) {
      if (this.pageCollection && isNaN(page)) {
        let { pagina } = this.$store.state.vuetableState[this.pageCollection]
        pagina = page === 'next' ? pagina + 1 : pagina - 1
        page = pagina
      }

      if (this.pageCollection) {
        this.$store.commit('SET_FILTER_PAGE', {
          collection: this.pageCollection,
          value: page
        })
      }

      this.$refs.vuetable.changePage(page)
    },
    onSuccess(response) {
      this.$emit('load-sucesso', response)
      if (this.dataPath) {
        this.totalRows = response.data[this.dataPath].length
      } else {
        this.totalRows = response.data.length
      }
    },
    onError({ response: { status, data } }) {
      switch (status) {
        case 401:
          if (store.state.initialized) {
            router.app.$toastr.e('Seu token expirou faça o login novamente!')
            router.app.$refs.loginModal.show(true)
          } else {
            store.commit('LOGOUT_USER')
            router.push({
              name: 'Login',
              params: { errorMsg: data.msg }
            })
          }
          break

        case 400:
          if (store.state.initialized) {
            router.app.$toastr.e('Seu token expirou faça o login novamente!')
            router.app.$refs.loginModal.show(true)
          } else {
            store.commit('LOGOUT_USER')
            router.push({
              name: 'Login',
              params: { errorMsg: data.msg }
            })
          }
          break
      }
    },
    onFilterSet(filterParams) {
      let filterText = filterParams[0]
      let fieldName = filterParams[1]

      if (!filterText || !fieldName) return

      this.appendParams[fieldName] = filterText

      Vue.nextTick(() => this.$refs.vuetable.refresh())
    },
    onFilterReset(fieldName) {
      this.appendParams[fieldName] = ''
      Vue.nextTick(() => this.$refs.vuetable.refresh())
    },
    onColumnVisibilityChanged() {
      this.$refs.vuetable.normalizeFields()
    }
  },
  mounted() {
    this.$events.$on('filter-set', e => this.onFilterSet(e))
    this.$events.$on('filter-reset', e => this.onFilterReset(e))
    this.$events.$on('column-visibility:changed', e =>
      this.onColumnVisibilityChanged(e)
    )
  }
}
</script>
<style scoped>
.pagination {
  margin: 0;
}

.btn.btn-border {
  border: 1px solid;
  margin-right: 2px;
}

.vuetable-pagination-info {
  margin-top: 8px !important;
}

.actions {
  margin-bottom: 4px;
}

.custom-table-font {
  color: #002220;
}
</style>



// WEBPACK FOOTER //
// src/components/common/DataTable.vue